import historyHandler from 'jd-library/historyHandler';
import React, { useState } from 'react'
import { connect } from 'react-redux';
import {
	setSelectedGalleryImages,
	toggleGalleryModal
} from '../../actions/photosGallery';
import toastMessageActions from "jd-library/toastMessageActions";
import { AddProductModal, DeletePhotosModal } from './PhotoModals';
import SearchProductsSlider from './SearchProductsSlider';
import SelectProductSlider from './SelectProductSlider';
import withPortal from 'jd-library/withPortal';
import { clickTrack } from '../../actions/products';

const PhotoGallerySliders = (props) => {
	const {
		selectedImages,
		deleteModal,
		addModal
	} = props;
    const [productSlider, toggleProductSlider] = useState({});
    const [searchProductsSlider, toggleSearchSlider] = useState({});
	
	return (
		<>
		{
			productSlider.show &&
			<SelectProductSlider 
				onHidden={() => toggleProductSlider({})}
				onSearchIconClick={() => {
					toggleSearchSlider({
						show: true,
						isPhoto: true
					})
				}}
				onSelectProduct={(data)=>{
					if(props.session.source == 'webstore'){
						if(data.isTemplate){
							props.showToastMessage({
								message: 'Photos cannot be added to products added from Omni Product Library',
								showToastMessage: true,
								animationTime :5000
							})
							return;
						}else if(props.allProducts[data.variantId] && props.allProducts[data.variantId].variantStatus){
							props.showToastMessage({
								message: 'Photos cannot be added to Multivariant products',
								showToastMessage: true,
								animationTime :5000
							})
							return;	
						}
					}
					props.toggleGalleryModal({
						addModal: {
							mode: 'confirmation',
							prodData: data,
							show: true
						}
					})
				}}
			/>
		}
		{
			searchProductsSlider.show &&
			<SearchProductsSlider 
				onHidden={() => toggleSearchSlider({})}
				isPhoto={searchProductsSlider.isPhoto}
				onSelectProduct={(data)=>{
					console.log(data);
					if(props.session.source == 'webstore'){
						if(data.isTemplate){
							props.showToastMessage({
								message: 'Photos cannot be added to products added from Omni Product Library',
								showToastMessage: true,
								animationTime :5000
							})
							return;
						}else if(data.variantStatus){
							props.showToastMessage({
								message: 'Photos cannot be added to Multivariant products',
								showToastMessage: true,
								animationTime :5000
							})
							return;	
						}
					}
					props.toggleGalleryModal({
						addModal: {
							mode: 'confirmation',
							prodData: data,
							show: true,
							redirectedFrom: 'searchProd'
						}
					})
				}}
			/>
		}
		{
			deleteModal.show && 
			<DeletePhotosModal 
				onHidden={() => props.toggleGalleryModal({
					deleteModal: {
						show: false
					}
				})}
				isMobile={props.isMobile}
				selectedImages={selectedImages}
				deletePhotos={()=> props.deletePhotos(true)}
			/>
		}
		{
			addModal.show && 
			<AddProductModal
				onHidden={()=>props.toggleGalleryModal({
					addModal: {
						show: false
					}
				})}
				isMobile={props.isMobile}
				addToExisting={()=>{
					historyHandler.closeCurrent();
					setTimeout(() => {
						toggleProductSlider({
							show: true
						});
					}, 250)
				}}
				deletePhotos={props.deletePhotos}
				productData={addModal.prodData}
				mode={addModal.mode}
				redirectedFrom={addModal.redirectedFrom}
				createNew={(productData,bifurcateType,fromAI) => {props.combinePhotos(productData,bifurcateType,fromAI)}}
				imageArr={(props.vendorImages && props.vendorImages.filter((cur, index)=>selectedImages.includes(index))) || []}
				payload={props.session}
				showToast={props.showToastMessage}
				isJdPhotoSlider={props.isJdPhotoSlider}
				profileObject={props.session?.profileObject}
				tabKey={props.tabKey}
				supplierId={props.supplierId}
				clickTrack={props.clickTrack}
				viaOmni={props.session?.viaOmni}
			/>
		}
		</>
	)
}

const mapStateToProps = (state, props) => {
	const newProps = {
		...props,
		vendorImages: state.products.vendorImages,
		supplierId: state.session.supplierId,
		session: state.session,
		selectedImages: state.photosGallery.selectedImages,
		addModal: state.photosGallery.addModal,
		deleteModal: state.photosGallery.deleteModal,
		allProducts: state.products.allProducts,
		isMobile: state.deviceData.isMobile,
		user: state.session.user,
		tabKey:state.products.tabKey,
	};
	const isJdPhotoSlider = props.isJdPhotoSlider || state.photosGallery.isJdPhotoSlider;
	if(isJdPhotoSlider) {
		newProps.isJdPhotoSlider = true;
		newProps.vendorImages = state.products.jdGalleryImages;
	}
	return newProps;
}

export default connect(mapStateToProps, {
	setSelectedGalleryImages,
	toggleGalleryModal,
	showToastMessage: toastMessageActions.showMessage,
	clickTrack
})(PhotoGallerySliders)